<template>
<div class="content-body tenant-settings">
    <!-- <div class="" style="background: red ;display: none"> -->
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="物料编码:">
                <el-input size="small" v-model="dataForm.materialCode" placeholder="物料编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="物料中文描述:">
                <el-input size="small" v-model="dataForm.materialName" placeholder="物料中文描述" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="物料组:">
                <el-input size="small" v-model="dataForm.materialGroup" placeholder="物料组" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="物料组描述:">
                <el-input size="small" v-model="dataForm.materialGroupName" placeholder="物料组描述" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small"  type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-upload2">
                    导入
                </el-button> -->

                <!-- <el-upload :limit="1" class="upload-demo" ref="upload" action :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :auto-upload="false" :http-request="UploadSubmit">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
                </el-upload> -->
                <el-upload class="file" action :show-file-list="false" :on-success="handleFileSuccess" :http-request="UploadSubmit" style="float:right;padding-left:5px">
                    <el-button slot="trigger" size="small" type="primary" icon="el-icon-plus">导入</el-button>
                </el-upload>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :header-cell-style="{background:'#f5f5f5'}" border :data="dataList" row-key="id" size="mini" style="width: 100%;" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                </el-table-column>
                <el-table-column prop="factoryCode" header-align="center" align="left" label="工厂" width="200">
                    <template slot-scope="scope">
                        {{getFactoryName(scope.row.factoryCode)}}
                    </template>
                    <!-- <span v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                </span> -->
                </el-table-column>
                <el-table-column prop="materialCode" header-align="center" align="left" label="物料编码">
                </el-table-column>
                <el-table-column prop="materialName" header-align="center" align="left" label="物料中文描述" width="150">
                </el-table-column>
                <el-table-column prop="materialGroup" header-align="center" align="center" label="物料组" width="100">
                </el-table-column>
                <el-table-column prop="materialGroupName" header-align="center" align="left" label="物料组描述" width="120">
                </el-table-column>
                <el-table-column prop="basicUnit" header-align="center" align="center" label="基本计量单位" width="100">
                    <template slot-scope="scope">
                        {{getUnitName(scope.row.basicUnit)}}
                    </template>
                </el-table-column>
                <el-table-column prop="auxiliaryUnit" header-align="center" align="center" label="辅助单位" width="80">
                    <template slot-scope="scope">
                        {{getUnitName(scope.row.auxiliaryUnit)}}
                    </template>
                </el-table-column>
                <el-table-column prop="numerator" header-align="center" align="center" label="转换分子" width="80">
                </el-table-column>
                <el-table-column prop="denominator" header-align="center" align="center" label="转换分母" width="80">
                </el-table-column>
                <el-table-column header-align="center" align="left" width="190" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <part-add-or-update v-if="partAddOrUpdateVisible" ref="PartAddOrUpdate" @refreshDataList="getDataList"></part-add-or-update>
    </div>
</div>
</template>

<script>
import {
    partList,
    deletePart,
    importFile
    // list
} from '@/controller/mdata'
import {
    getFactoryList,
    getUnitList
} from '@/controller/systemData'
import PartAddOrUpdate from './part-add-or-update'
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 260,
            dataForm: {
                factoryCode: '',
                materialCode: '',
                basicUnit: '',
                auxiliaryUnit: '',
                numerator: '',
                denominator: '',
                materialName: '',
                materialGroup: '',
                materialGroupName: ''
            },
            dataList: [],
            tenantList: [],
            factoryList: [],
            unitList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            partAddOrUpdateVisible: false,
            fileList: [],
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 260
            }
        }
    },

    components: {
        PartAddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    methods: {
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.getFactoryList()
            this.getUnitList()
            partList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'factoryCode': this.dataForm.factoryCode,
                'materialCode': this.dataForm.materialCode,
                'basicUnit': this.dataForm.basicUnit,
                'auxiliaryUnit': this.dataForm.auxiliaryUnit,
                'numerator': this.dataForm.numerator,
                'denominator': this.dataForm.denominator,
                'materialName': this.dataForm.materialName,
                'materialGroup': this.dataForm.materialGroup,
                'materialGroupName': this.dataForm.materialGroupName,
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
        },
        getUnitList() {
            getUnitList({
                code: '',
                name: ''
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            })
        },
        getFactoryName(code) {
            const factory = this.factoryList.find(factory => factory.factoryCode === code)
            return factory ? factory.factoryDesc : ''
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.partAddOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.PartAddOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            this.partAddOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.PartAddOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePart({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        UploadSubmit(param) {
            //console.log(param.file);
            var file = param.file;
            var file_form = new FormData(); //获取上传表单（文件）
            file_form.append("file", file);
            importFile(file_form).then(data => {
                if (data && data.code === '00') {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.getDataList()
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            });
        },
        // submitUpload() {
        //     this.$refs.upload.submit();
        // },
        // handleRemove(file, fileList) {
        //     console.log(file, fileList);
        // },
        // handlePreview(file) {
        //     console.log(file);
        // },
        // 文件-图片-上传成功返回内容
        handleFileSuccess(res) {
            if (res) {
                let arr = {
                    type: this.type,
                    data: res.data
                };
                // 抛出的数据内容
                this.$emit("handleSuccess", arr);
                this.$message.success("上传成功！");
            }
        },
        // // 文件-图片-上传操作
        // uploadLicencePicNo(param) {
        //     var file = param.file;
        //     var file_form = new FormData(); //获取上传表单（文件）
        //     file_form.append("file", file);
        //     importFile(e).then(() => {});
        // }
    }
}
</script>

<style lang="scss" scoped>
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
